import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import {
	Box,
	Heading,
	Table,
	Thead,
	Tbody,
	Tfoot,
	Tr,
	Th,
	Td,
	TableCaption,
} from '@chakra-ui/react';
import { format } from '../utils';
import { options } from './data';

const getCustomerName = (customer, structured) => {
	if (!structured) return customer
	if (customer.length > 1) return customer
	const parsed = JSON.parse(structured)
	const {sponsor} = parsed
	if (!sponsor) return customer
	const {first_name, last_name} = sponsor
	return first_name + ' ' + last_name
}

export const Log = ({ wakeLog, setWakeLog, setUserID }) => {
	const [loading, setLoading] = useState(true);
	const [logs, setLogs] = useState([]);
	useEffect(() => {
		let active = true;
		async function load() {
			const res = await axios.get('/logs', options());
			if (!active) {
				return;
			}
			setLogs(res.data.logs);
			setLoading(false);
		}
		load();

		return () => {
			active = false;
		};
	}, [wakeLog]);

	if (loading) return <p>Loading...</p>;

	return (
		<Box p={4}>
			<Heading fontSize={'3xl'} mb="6">
				Customers Log
			</Heading>
			<Table variant="simple">
				<TableCaption>Журнал работы с клиентами</TableCaption>
				<Thead>
					<Tr>
						<Th>Time</Th>
						<Th>Customer</Th>
						<Th>Event</Th>
					</Tr>
				</Thead>
				<Tbody>
					{logs.map(({ id, created_at, customer_id, customer, structured, content }) => {
						const when = moment(created_at).format('DD.MM HH:mm');
						const customerName = getCustomerName(customer, structured)
						return (
							<Tr key={id}>
								<Td>{when}</Td>
								<Td
									color="Teal"
									fontWeight="700"
									cursor="pointer"
									onClick={async () => {
										await setUserID(-1);
										await setUserID(customer_id);
									}}
								>
									{customerName}
								</Td>
								<Td>{format(content)}</Td>
							</Tr>
						);
					})}
				</Tbody>
				<Tfoot>
					<Tr>
						<Th>Time</Th>
						<Th>Customer</Th>
						<Th>Event</Th>
					</Tr>
				</Tfoot>
			</Table>
		</Box>
	);
};
